import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppConstants, LMDialogButtonKey } from '@utils/app.constants';
import { SohoAlertDirective, SohoMessageService, SohoSpinboxComponent } from 'ids-enterprise-ng';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMSpecService } from '@services/lm-spec.service';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { LMGlobalPersonalizationService } from '@app/states';

@Component({
  selector:    'lm-filter-builder',
  templateUrl: './lm-filter-builder.component.html',
  styleUrls:   [ './lm-filter-builder.component.scss' ]
})
export class LMFilterBuilderComponent implements OnInit {

  @ViewChild(SohoSpinboxComponent) spinboxComponent: SohoSpinboxComponent;
  @ViewChild(SohoAlertDirective) alert: SohoAlertDirective;

  @Input() businessClass: string;
  @Input() includeAuditFields: boolean;
  @Input() lookupUrl: string;
  @Input() fieldSearchUrl: string;
  @Input() lplValidationUrl: string;

  @Output() filterData = new EventEmitter<LMFieldFilterData>();

  public static MATCH_OPTION_ALL = 'all';
  public static MATCH_OPTION_ANY = 'any';
  useCompactFormLayout = false;
  separator: string;

  buildAnotherLabel: string;
  uniqueRowIdentifier = 0;

  public model = {
    conditionString:   '',
    includeBaseFilter: false,
    matchOption:       '',
    businessClass:     '',
    listName:          '',
  };

  private _filterRows = new Array<FilterRow>();

  get filterRows(): Array<FilterRow> {
    return this._filterRows;
  }

  get matchOption(): string {
    if (this.model.matchOption === LMFilterBuilderComponent.MATCH_OPTION_ALL) {
      return AppConstants.CONDITION_AND;
    } else if (this.model.matchOption === LMFilterBuilderComponent.MATCH_OPTION_ANY) {
      return AppConstants.CONDITION_OR;
    }
  }

  constructor(private lmSpecService: LMSpecService,
    private lmLoggerService: LMLoggerService,
    private changeDetectorRef: ChangeDetectorRef,
    private sohoMessageService: SohoMessageService,
    private lmUniqueIdService: LMUniqueIdService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService) {
  }

  ngOnInit() {
    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout;

    this.buildAnotherLabel = Soho.Locale.translate('BuildAnother');
    this.model.matchOption = LMFilterBuilderComponent.MATCH_OPTION_ALL;
    this.separator = AppConstants.CONDITION_AND;
    this.createOneFilterRowEntry();
  }

  private createOneFilterRowEntry() {
    this.filterRows.push({
      uniqueIdentifier: this.buildUniqueIdentifier(),
      subject:   { text: '', type: 'TEXT' },
      condition: '',
      predicate: { text: '', type: 'TEXT' },
      literal:   false
    });
  }

  onMatchChange(event: Event) {
    if (this.model.matchOption === LMFilterBuilderComponent.MATCH_OPTION_ALL
      && this.separator === AppConstants.CONDITION_OR) {
      this.separator = AppConstants.CONDITION_AND;
    } else if (this.model.matchOption === LMFilterBuilderComponent.MATCH_OPTION_ANY
      && this.separator === AppConstants.CONDITION_AND) {
      this.separator = AppConstants.CONDITION_OR;
    }
  }

  onRemoveButtonEvent(event: LMFilterBuilderRemoveRowEvent, index: number) {

    if (this.filterRows.length === 1) {
      this.filterRows[ 0 ].subject.text = '';
      this.filterRows[ 0 ].subject.type = 'TEXT';
      this.filterRows[ 0 ].predicate.text = '';
      this.filterRows[ 0 ].predicate.type = 'TEXT';
    } else {
      this.filterRows.splice(index, 1);
    }
  }

  onAddButtonEvent(event: Event) {
    this.createOneFilterRowEntry();
  }

  validateFilterConditions(): boolean {
    let valid = true;

    this.filterRows.forEach(filterRow => {
      valid = this.validateFilterCriteria(filterRow);
    });

    if (valid) {
      return true;
    } else {
      const buttons = [
        // tslint:disable-next-line - shadowed variable e,
        {
          id: this.lmUniqueIdService.uniqueId([ 'ValidationError', LMDialogButtonKey.OK ]),
          text: Soho.Locale.translate(LMDialogButtonKey.OK),
          isDefault: true,
          click: (e, modal) => {
            modal.close(true);
          }
        }
      ];
      this.sohoMessageService
        .message()
        .message(`<span> ${Soho.Locale.translate('ConditionLineError')} </span>`)
        .title(Soho.Locale.translate('ValidationError'))
        .buttons(buttons)
        .open();
    }
    return false;
  }

  private buildUniqueIdentifier(): number {
    return this.uniqueRowIdentifier++;
  }

  private validateFilterCriteria(filterRow: FilterRow): boolean {
    if (filterRow.subject.text === ''
      || filterRow.condition === ''
      || filterRow.subject.text.trim().length === 0
      || filterRow.condition.trim().length === 0) {
      return false;
    }

    if (!(filterRow.subject.type === 'BOOLEAN'
      || filterRow.subject.type === 'OTO_RELATION'
      || filterRow.subject.type === 'OTM_RELATION'
      || filterRow.subject.type === 'CONDITION'
      || filterRow.subject.type === 'STATE'
      || filterRow.condition === 'entered'
      || filterRow.condition === 'notEntered')
      && (filterRow.predicate.text === '' || filterRow.predicate.text.trim().length === 0)) {
      return false;
    }

    if (filterRow.predicate.type === 'OTO_RELATION' || filterRow.predicate.type === 'OTM_RELATION') {
      return false;
    }

    return true;
  }

  public reset() {
    this._filterRows = [];
    this.createOneFilterRowEntry();
  }
}
